// Leave action types
export const LEAVE_GET_ALL = "LEAVE_GET_ALL";
export const LEAVE_SET_FILTERS = "LEAVE_SET_FILTERS";
export const LEAVE_CLEAR_FILTERS = "LEAVE_CLEAR_FILTERS";
export const LEAVE_SET_STATE = "LEAVE_SET_STATE";
export const LEAVE_PAGE_RESET = "LEAVE_PAGE_RESET";
export const LEAVE_SET_LOADING = "LEAVE_SET_LOADING";
export const LEAVE_SET_ERROR = "LEAVE_SET_ERROR";
export const LEAVE_CLEAR_ERROR = "LEAVE_CLEAR_ERROR";
export const LEAVE_DETAILS_SUCCESS = "LEAVE_DETAILS_SUCCESS";
export const LEAVE_DETAILS_FAILURE = "LEAVE_DETAILS_FAILURE";
export const LEAVE_DETAILS_RESET = "LEAVE_DETAILS_RESET";
export const LEAVE_SET_SELECTED = "LEAVE_SET_SELECTED";
export const LEAVE_MANAGE_REQUEST = "LEAVE_MANAGE_REQUEST";
export const LEAVE_MANAGE_SUCCESS = "LEAVE_MANAGE_SUCCESS";
export const LEAVE_MANAGE_FAILURE = "LEAVE_MANAGE_FAILURE";